import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/package-sub';

const list = (merchantId, branchId, page = 1, pageSize = 10000) => {
	return Client.get(`${baseUrl}/subscriptions`, {
		merchantId,
		branchId,
		page,
		pageSize,
	});
};

export default { list };
